import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Clock, User } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

export const ModificationHistoryModal = ({ isOpen, onClose, history, entryDescription }) => {
  const formatDate = (dateStr) => {
    try {
      return format(new Date(dateStr), 'dd/MM/yyyy à HH:mm', { locale: fr });
    } catch {
      return dateStr;
    }
  };

  const getFieldLabel = (field) => {
    const labels = {
      description: 'Description',
      quantity: 'Quantité',
      purchase_price: 'Prix Achat',
      sale_price: 'Prix Vente',
      payment_method: 'Mode de paiement'
    };
    return labels[field] || field;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="modification-history-modal">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-slate-900">
            Historique des modifications
          </DialogTitle>
          <p className="text-sm text-slate-500 mt-1">{entryDescription}</p>
        </DialogHeader>

        <div className="space-y-3 mt-4">
          {history && history.length > 0 ? (
            history.map((mod, idx) => (
              <div
                key={idx}
                className="bg-slate-50 rounded-lg p-4 border border-slate-200"
                data-testid="modification-record"
              >
                <div className="flex items-center gap-2 text-xs text-slate-500 mb-2">
                  <Clock className="w-3 h-3" />
                  <span>{formatDate(mod.modified_at)}</span>
                </div>
                <div className="text-sm">
                  <span className="font-medium text-slate-700">{getFieldLabel(mod.field)}</span>
                  <div className="mt-1 flex items-center gap-2">
                    <span className="text-red-600 line-through">{mod.old_value}</span>
                    <span className="text-slate-400">→</span>
                    <span className="text-emerald-600 font-medium">{mod.new_value}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-slate-400">
              Aucune modification enregistrée
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModificationHistoryModal;
